import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CommonService } from "@services/common.service";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
@Component({
    selector: "app-publishing",
    templateUrl: "./publishing.component.html",
    styleUrls: ["./publishing.component.scss"],
    standalone: false
})
export class PublishingDialogComponent implements OnInit {
  message: string = "Are you sure?";
  actionButton: string = "delete";
  messageDetail: string = "";
  details: any = [];
  constructor(
    public commonService: CommonService,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<PublishingDialogComponent>
  ) {
    if (data) {
      this.message = data.message || this.message;
      this.messageDetail = data.messageDetail || this.messageDetail;
      this.details = data.details || this.details;
      this.actionButton = data.actionButton || this.actionButton;
      if (data.actionButton) {
        this.actionButton = data.actionButton;
      }
    }
  }
  public publishForm!: UntypedFormGroup;
  today = new Date();

  onNoClick(): void {
    this.dialogRef.close();
  }
  onConfirmClick(): void {
    this.dialogRef.close(true);
    //this.commonService.openRoadmapLinkDialog(event);
  }
  ngOnInit(): void {
    this.publishForm = this.fb.group({
      schedule: new UntypedFormControl("immediate", [Validators.required]),
      date: new UntypedFormControl(),
    });
  }
}
